import formMainHubGeneralSettings from './formMainHubGeneralSettings';


export default {
  title: 'App General Settings',
  attributeName: 'mainHubGeneralSettings',
  getURL: 'mainHubs/mainHubId/GeneralSetting',
  createURL: '',
  updateURL: 'mainHubs/mainHubId/GeneralSetting',
  removeURL: '',
  sessionParams: ['mainHubId'],
  noArea:true,
  formConfig: [
    formMainHubGeneralSettings,
  ],
  idUpdate: true,
  autoUpdate: false,
};
